import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BellPlus, BellRing } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

/* Follow any world airport — instant breaking alerts + daily digest emails. */
export const FollowAirportButton = ({ iata, className = "" }) => {
  const { user } = useAuth();
  const nav = useNavigate();
  const [following, setFollowing] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!user || !iata) return;
    api.get("/aviation-news/following")
      .then((r) => setFollowing((r.data.iatas || []).includes(iata))).catch(() => {});
  }, [user, iata]);

  if (!iata) return null;

  const toggle = () => {
    if (!user) { toast.info("Sign in to follow airports and get breaking alerts"); nav("/login"); return; }
    setBusy(true);
    api.post(`/aviation-news/${following ? "unfollow" : "follow"}`, { iata })
      .then(() => {
        setFollowing(!following);
        toast.success(!following ? `Following ${iata} — you'll get breaking news alerts by email` : `Unfollowed ${iata}`);
      })
      .catch((err) => toast.error(err.response?.data?.detail || "Could not update follow"))
      .finally(() => setBusy(false));
  };

  return (
    <button onClick={toggle} disabled={busy} data-testid="follow-airport-btn"
      className={`inline-flex items-center gap-2 px-4 py-2.5 font-600 text-sm transition-colors ${following ? "bg-amber-500 text-white hover:bg-amber-600" : "bg-white/15 text-white border border-white/40 hover:bg-white/25"} ${className}`}>
      {following ? <BellRing className="w-4 h-4" /> : <BellPlus className="w-4 h-4" />}
      {following ? "Following" : "Follow for alerts"}
    </button>
  );
};
